import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {StorageService} from '../../services/storage/storage.service';
import {UtilitiesService} from '../../services/utilities-service/utilities.service';
import {ActivatedRoute} from '@angular/router';
import {fadeInAnimation} from '../../animations/fade-in.animation';
import {IUser} from '../../models/auth';

@Component({
  selector: 'app-user-register-share-data',
  templateUrl: './user-register-share-data.component.html',
  styleUrls: ['./user-register-share-data.component.scss'],
  animations: [fadeInAnimation]
})
export class UserRegisterShareDataComponent implements OnInit {
  @Output() alreadyAcceptInvitation: EventEmitter<boolean> = new EventEmitter<boolean>();
  user: IUser;
  constructor(
    private storageService: StorageService,
    private utilityService: UtilitiesService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    const clinicId = this.utilityService.getAllParams(this.activatedRoute).clinicId;
    const acceptInvitation = this.storageService.getLocalItem<{clinicId: string, accept: boolean}>('acceptInvitation');
    this.user = this.storageService.getLocalItem<{token: string, user: IUser}>('user')?.user;
    if (acceptInvitation && acceptInvitation.clinicId === clinicId && acceptInvitation.accept) {
      setTimeout(() => {
        this.alreadyAcceptInvitation.emit(true);
      }, 100);
    }
  }

}
